export default "__VITE_ASSET__CQTHFg5v__"